/**
 * MyPage — 내 정보 (PKA 화면정의서 SC-005 · 기능명세 FN-040~044 · PRD §4.3).
 *
 * ⚠ 2026-08-19 개편. **설정 화면(/me/settings)을 없애고 여기로 전부 합쳤다.**
 *   설정은 픽쿠리 템플릿(Figma 885:27840)에서 넘어온 화면이라 화면정의서에도
 *   기능명세서에도 대응 항목이 없었고, 이용약관·로그아웃·앱 버전이 내 정보와
 *   양쪽에 **둘 다** 있었다. SC-005 는 원래 이 항목들을 전부 내 정보의 구성요소로
 *   적어 두고 있다 — 그래서 합치는 쪽이 명세와도 맞는다.
 *
 * 구성 (SC-005 구성요소 순서 그대로):
 *   ① 계정      — 프로필 + 플랜 배지
 *   ② 내 통계   — 내 카드 · 스캔 기록 · 총 평가액 + 상위 3 카드 (FN-041, 실 API)
 *   ②' 후원     — 개발자 후원 · 건전지 (SC-023 · 수익모델 §4). 구독이 있던 자리다
 *   ③ 표시 설정 — 통화(SC-017) · 표시 언어(FN-054) · 카드 에디션(SC-009)
 *   ④ 알림 설정 — 마스터 + 받을 알림 4종 + 방해 금지 (FN-063 · SC-024 폐기 후 인라인)
 *   ⑤ 지원      — 고객센터 · 이용약관 · 개인정보처리방침 · 앱 버전 (FN-044)
 *   ⑥ 계정      — 로그아웃 · 탈퇴 (백업/복구는 뺐다 — 아래 ⚠ 참조)
 *   (⑦ 사업자 정보 푸터는 2026-09-07 디자인·기획 협의로 뺐다. ⚠ 이제 앱 안에는 사업자
 *    등록번호·주소·대표번호가 어디에도 없다(약관 본문은 회사명뿐). 응원(IAP)은 수익모델
 *    §4.3 상 디지털 상품 판매라 전자상거래법 §10 표시 의무 대상 — 출시 전 자리를 다시 정할 것.
 *    Footer 컴포넌트(components/layout/Footer)는 남겨 뒀다)
 *
 * 📌 계정(로그아웃·탈퇴)은 2026-08-20 에 앱 버전 아래로 내렸다. 화면을 떠나는
 *   액션이라 설정·지원 사이에 끼어 있으면 스크롤 중에 손이 먼저 닿는다.
 *   맨 아래에 두면 "다 보고 나서 나가는 자리" 가 된다.
 *
 * 📌 '가장 비싼 카드 TOP 3' 는 지웠다 (2026-09-17 사용자 결정). 기획확정안 §6.3 이
 *   컬렉션의 표시 항목으로 적어 둔 것이고 그 계산은 컬렉션 화면에 이미 있다 —
 *   내 정보에 한 벌 더 두면 같은 목록을 두 화면이 말한다.
 *
 * 📌 '비밀번호 변경' 은 지웠다 (2026-08-19). peeka 는 구글·카카오·네이버·애플
 *   소셜 로그인만 쓰므로 눌러도 항상 "변경 불가" 토스트만 떴다. 자체 이메일
 *   가입이 생기면 ⑥ 계정에 되살릴 것.
 *
 * 알림 토글: BE 와 wire — 마운트 시 GET 으로 hydration, 토글 시 PUT.
 *   실패 시 토글 revert + 토스트. push 가 OFF→ON 될 때 native permission 선행.
 *   ⚠ 키(NotiKey)와 BE 필드는 템플릿 시절 이름 그대로다 — 서버 계약이라 FE 가
 *     임의로 못 바꾼다. 그래서 이름과 뜻이 어긋난 자리가 남는다:
 *       deliveryGift → deliveryNotiYn     인데 화면에서는 '스캔 알림'
 *       storagePoint → storagePointNotiYn 인데 화면에서는 '컬렉션 알림'
 *     BE 알림 분류를 peeka 기준으로 다시 정의할 때 키·필드까지 함께 정리할 것.
 *
 * 디버그 메뉴 진입 (개발자/QA 전용):
 *   "앱 버전" 행을 첫 탭 시점부터 TAP_WINDOW_MS(3초) 안에 10번 탭 → DebugUnlockDialog.
 *
 * ⚠ **명세에 있는데 앱에 없는 것** (2026-08-19 대조):
 *   - FN-043 데이터 백업/복구 — 라우트가 없어 '준비 중' 행으로 두다가 2026-09-07 에
 *     행 자체를 뺐다(컬렉션이 서버 저장이라 백업할 로컬 데이터가 없다, ⑥ 주석 참조).
 *   - FN-044 [지원] 은 명세상 고객센터·도움말·평가하기·설정 4개인데 고객센터뿐이다.
 *     도움말 화면과 스토어 평가 링크가 아직 없다.
 *   - FN-040 통화는 이 화면의 로컬 상태다 — 앱을 껐다 켜면 KRW 로 돌아간다.
 *   - FN-054 표시 언어는 앱 문구까지만 바뀐다. 명세가 요구하는 카드·세트명 번역은
 *     카드 데이터에 언어별 이름 필드가 없어 아직 안 된다.
 *   넷 다 서버·라우트 배선이 필요한 **개발 작업**이라 여기서 만들지 않는다.
 *
 * 벤치마크(MonPrice)에만 있고 Peeka 에 없는 것은 옮기지 않았다 —
 * 'MonPrice 박스', 개발사 타 앱 크로스프로모, Google 구독 센터.
 *
 * ⚠ 통화는 이 화면의 로컬 상태다 — 서버 배선은 개발 작업이라 여기서 만들지 않는다.
 * (표시 언어는 i18n `setAppLanguage` 가 이미 있어 실제로 바뀐다.)
 */
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { Avatar } from "@astryxdesign/core/Avatar";
import { Button } from "@astryxdesign/core/Button";
import { IconButton } from "@astryxdesign/core/IconButton";
import { Card } from "@astryxdesign/core/Card";
import { Divider } from "@astryxdesign/core/Divider";
import { EmptyState } from "@astryxdesign/core/EmptyState";
import { Grid, GridSpan } from "@astryxdesign/core/Grid";
import { Item } from "@astryxdesign/core/Item";
import { List } from "@astryxdesign/core/List";
import Icon from "../../components/primitives/Icon";
import DonationSheet from "../../components/donation/DonationSheet";
import {
  BATTERY_KEY,
  useBatteryCountQuery,
  useDonationEnabledQuery,
} from "../../hooks/useDonationQueries";
import { BATTERY_TIER_COLOR, batteryTier } from "../../data/donation";
import { Section } from "@astryxdesign/core/Section";
import { Switch } from "@astryxdesign/core/Switch";
import { Heading } from "@astryxdesign/core/Heading";
import { Text } from "@astryxdesign/core/Text";
import { TextInput } from "@astryxdesign/core/TextInput";
import { ToggleButton } from "@astryxdesign/core/ToggleButton";
import { VStack, HStack } from "@astryxdesign/core/Layout";
import DebugUnlockDialog from "../../components/feedback/DebugUnlockDialog";
import Sheet from "../../components/feedback/Sheet";
import { useToast } from "../../components/feedback/Toast";
import PullToRefresh from "../../components/feedback/PullToRefresh";
import { useEdition } from "../../components/edition/EditionContext";
import {
  fetchNotificationSettings,
  updateNotificationSettings,
  type NotificationSettings,
} from "../../api/member";
import { CURRENCIES } from "../../data/currencies";
import { formatKrwCompact } from "../../data/dummyCards";
import { EDITIONS } from "../../data/priceModel";
import { formatKrw } from "../../lib/formatPrice";
import { listRecentScans } from "../../lib/recentScans";
import { SUPPORTED_LANGUAGES, currentLanguage, setAppLanguage, type AppLanguage } from "../../i18n";
import { isNative } from "../../native";
import { ensurePushPermission } from "../../native/pushPermission";
import { getCurrentNativeVersion, getCurrentOtaVersion } from "../../native/liveUpdate";
import { useAuthStore } from "../../store/authStore";
import { useCurrencyStore, DEFAULT_DISPLAY_CURRENCY } from "../../store/currencyStore";
import { useDebugStore } from "../../store/debugStore";
import { useCollectionQuery, COLLECTION_KEY } from "../../hooks/useCollectionQueries";
import { useMeQuery, ME_KEY } from "../../hooks/useMemberQueries";
import { useMoney } from "../../hooks/useMoney";
import { useOverlayNavigate } from "../../hooks/useOverlayNavigate";
import { useActivityNavigator } from "../../navigation/useActivityNavigator";
import styles from "./MyPage.module.css";

/** ⑥ 지원·약관 메뉴 — 라벨은 i18n 키, 이동은 라우트. */
const SUPPORT_MENU = [
  { key: "helpCenter", to: "/support" },
  // '설정' 은 뺐다 (design 2026-08-20) — 설정 화면을 이 화면으로 합쳤으므로
  // 자기 자신으로 가는 입구가 된다.
] as const;

/**
 * ⑥ 약관 메뉴.
 *
 * ⚠ `/legal/*`(PublicTermsPage) 로 보내지 않는다 — 그쪽은 구글 OAuth 동의화면·스토어
 * 심사용 **외부 공개 라우트**라 Layout 밖에 있고 activity 도 아니다. 앱 안에서 열면
 * 앱바가 없고 하드웨어 뒤로가기가 홈으로 튀었다(2026-08-17 실기기 제보).
 * 앱 안에서는 설정 화면과 같은 약관 뷰어 activity 를 쓴다.
 */
const LEGAL_MENU = [
  { key: "terms", type: "service" },
  { key: "privacy", type: "privacy" },
] as const;

/** 열려 있는 설정 시트. null = 닫힘. */
// ── 알림 (알림 정책 기획서 v1.3) ────────────────────────────────
type NotiKey = "push" | "shopping" | "storagePoint" | "deliveryGift" | "event" | "night";

/**
 * BE 키 → peeka 알림 유형.
 *
 * ── 2026-08-25 명세 4종으로 재정의 (오픈이슈 OI-23) ──────────────────
 * 기능명세 FN-063~067 이 알림 유형을 넷으로 확정했다:
 *   ① 시세 변동  ② 컬렉션 총액 요약  ③ 발견·트렌드  ④ 시스템·공지
 *
 * 알림 센터(SC-022)는 이 넷으로 이미 갈아 끼웠는데 **설정은 템플릿 그대로**여서,
 * 한 앱의 두 화면이 서로 다른 범주를 말하고 있었다. 여기서 맞춘다.
 *
 * ⚠ **BE 필드 이름은 못 바꾼다** — 서버 계약이다. 그래서 슬롯 넷에 유형 넷을
 *   얹는다. 둘은 뜻이 이어지고(관심→시세, 보관·포인트→컬렉션), 둘은 남은 자리를
 *   빌려 쓴다(배송·선물→발견, 혜택·소식→공지).
 *   BE 가 NOTI 필드를 peeka 기준으로 다시 정의하면(OI-23, 담당 개발) 이 표만
 *   갈아 끼우면 된다.
 */
const NOTI_I18N: Record<Exclude<NotiKey, "push" | "night">, string> = {
  shopping: "price",
  storagePoint: "collection",
  deliveryGift: "discover",
  event: "system",
};

/**
 * 마스터(푸시 알림 설정)가 제어하는 하위 토글 그룹.
 *   - 마스터 ON 클릭 → 하위 전체 ON / 마스터 OFF 클릭 → 하위 전체 OFF
 *   - 하위 ON       → 마스터 자동 ON
 * 방해 금지 모드(night)는 마스터와 독립.
 *
 * ⚠ **이 배열이 유일한 기준이다.** 화면에 그리는 것도, 마스터가 한꺼번에 켜고 끄는
 *   것도 전부 여기서 나온다 — 한쪽만 고치면 화면에 없는 알림이 조용히 켜진다.
 *
 * 📌 2026-08-19 에 둘로 줄였다가 2026-08-25 에 **넷으로 되돌렸다.** 명세가 유형을
 *   넷으로 확정했고(FN-063), 알림 센터도 넷으로 거른다 — 설정에 없는 유형이
 *   센터에는 있으면 끌 방법이 없는 알림이 생긴다.
 *   순서는 명세의 ①②③④ 를 따른다.
 */
const SUB_KEYS: readonly Exclude<NotiKey, "push" | "night">[] = [
  "shopping", // ① 시세 변동
  "storagePoint", // ② 컬렉션 총액 요약
  "deliveryGift", // ③ 발견·트렌드
  "event", // ④ 시스템·공지
];

// BE wire format (Y/N) ↔ FE state (boolean) 변환.
const NOTI_FIELD: Record<NotiKey, keyof NotificationSettings> = {
  push: "pushAgreementYn",
  shopping: "interestNotiYn",
  storagePoint: "storagePointNotiYn",
  deliveryGift: "deliveryNotiYn",
  event: "newsNotiYn",
  night: "nightQuietUseYn",
};
function toBooleans(s: NotificationSettings): Record<NotiKey, boolean> {
  return {
    push: s.pushAgreementYn === "Y",
    shopping: s.interestNotiYn === "Y",
    storagePoint: s.storagePointNotiYn === "Y",
    deliveryGift: s.deliveryNotiYn === "Y",
    event: s.newsNotiYn === "Y",
    night: s.nightQuietUseYn === "Y",
  };
}

const yn = (b: boolean): "Y" | "N" => (b ? "Y" : "N");
const pad2 = (n: number) => String(n).padStart(2, "0");

// "앱 버전" 표시: 네이티브 앱버전 + 현재 실행 중인 OTA 메타데이터 버전을 항상 병기.
function formatAppVersion(native: string | null, ota: string | null): string {
  if (!native && !ota) return "v1.0.0";
  if (!native) return `v${ota}`;
  if (!ota) return `v${native}`;
  return `v${native} (${ota})`;
}

const TAP_THRESHOLD = 10;
/** 첫 탭으로부터 이 시간 안에 TAP_THRESHOLD 번을 채워야 unlock dialog 가 뜸. */
const TAP_WINDOW_MS = 3000;

type SettingSheet = "currency" | "language" | "edition";

export default function MyPage() {
  const { t } = useTranslation("me");
  const overlayNavigate = useOverlayNavigate();
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const nav = useActivityNavigator();
  const navigate = useNavigate();
  const money = useMoney();
  const toast = useToast();
  const debugUnlocked = useDebugStore((st) => st.unlocked);
  const { edition, setEdition } = useEdition();

  // /support 는 독립 SubActivity — nav.open 으로 직접 진입.
  const openRoute = useCallback((to: string) => {
    if (to === "/support" || to.startsWith("/support?")) {
      nav.open({ url: to });
      return;
    }
    overlayNavigate(to, { state: { overlayFallbackPath: "/me" } });
  }, [nav, overlayNavigate]);

  // 로그인 응답에는 introduction/profileImageUrl 이 없으므로 Me 조회로 프로필 전체를
  // 보강해 store 에 동기화. 표시는 항상 store user 기준.
  const setUser = useAuthStore((s) => s.setUser);
  const { data: me } = useMeQuery();
  useEffect(() => {
    if (me) setUser(me);
  }, [me, setUser]);

  const displayName = user?.nickname?.trim() || user?.email?.split("@")[0] || t("guest");
  const introductionText = user?.introduction?.trim() || t("noIntroduction");

  const queryClient = useQueryClient();
  const handlePullRefresh = useCallback(async () => {
    await Promise.all([
      queryClient.refetchQueries({ queryKey: ME_KEY }),
      queryClient.refetchQueries({ queryKey: COLLECTION_KEY }),
    ]);
  }, [queryClient]);

  // ── 설정 상태 ────────────────────────────────────────────────
  const [openSheet, setOpenSheet] = useState<SettingSheet | null>(null);
  // 표시 통화는 전역 상태다 (FN-040) — 이 화면의 로컬 값이면 앱을 껐다 켤 때 원화로
  // 돌아가고, 다른 화면의 금액도 안 따라온다.
  const currency = useCurrencyStore((st) => st.currency);
  const setCurrency = useCurrencyStore((st) => st.setCurrency);

  /** 후원 시트 (SC-023). 여기는 상설 진열이라 빈도 규칙이 걸리지 않는다 */
  const [donationOpen, setDonationOpen] = useState(false);
  /* 개수의 출처는 서버(계정 기준)다 — 소모성 IAP 는 복원이 안 돼 기기에 두면 앱을
     지우는 순간 사라진다(OI-10). 후원 성공 시 훅이 알아서 무효화·재조회한다.

     ⚠ 로딩 중에는 0 이 아니라 **undefined** 로 둔다. 0 을 먼저 그리면 후원자가 자기
       표식이 사라졌다고 오해하고, 화면은 '건전지 0개' 같은 부재 표시를 만들지
       않기로 했다(수익모델 §4.3) — 값이 오기 전까지 표식 자리를 비워 둔다. */
  const { data: batteryData } = useBatteryCountQuery();
  const batteryCount = batteryData?.batteryCount ?? 0;
  /* 서버가 후원을 열어 뒀을 때만 이 자리를 그린다 — 스토어 상품 등록 전에 버튼을 그리면
     누르는 순간 실패하는 자리가 된다(useDonationEnabledQuery 주석). */
  const { data: donationEnabled } = useDonationEnabledQuery();
  /** 아직 아무것도 안 넣었으면 보조색 — 표식은 있는 것만 색을 갖는다 */
  const batteryTierNow = batteryTier(batteryCount);
  const batteryColor =
    batteryTierNow === "none"
      ? "var(--text-secondary)"
      : BATTERY_TIER_COLOR[batteryTierNow];
  const [language, setLanguage] = useState<AppLanguage>(currentLanguage);
  const [currencyQuery, setCurrencyQuery] = useState("");

  // ── ④ 알림 상태 ───────────────────────────────────────────
  const [noti, setNoti] = useState<Record<NotiKey, boolean>>({
    push: false,
    shopping: false,
    storagePoint: false,
    deliveryGift: false,
    event: false,
    night: false,
  });
  // 방해 금지 설명에 표시할 quiet hours (BE 값 기준). 마운트 시 hydration 으로 갱신.
  const [quietHours, setQuietHours] = useState<{ start: number; end: number }>({
    start: 22,
    end: 8,
  });
  // 동시 토글 충돌 방지 — PUT in-flight 상태.
  const [savingKey, setSavingKey] = useState<NotiKey | null>(null);
  const [hydrated, setHydrated] = useState(false);
  /* 알림 설정을 못 불러온 상태. 토스트가 아니라 **그 자리에** 적는다 (아래 참조) */
  const [notiLoadFailed, setNotiLoadFailed] = useState(false);
  const [otaVersion, setOtaVersion] = useState<string | null>(null);
  const [nativeVersion, setNativeVersion] = useState<string | null>(null);
  const [unlockOpen, setUnlockOpen] = useState(false);

  /**
   * 알림 설정을 BE 에서 불러온다. 마운트 때 한 번, 실패하면 사용자가 다시 부른다.
   *
   * ⚠ **실패를 토스트로 알리지 않는다** (2026-08-28 버그 수정).
   *   토스트는 '방금 내가 한 일' 의 결과를 알리는 자리다. 그런데 이건 화면에
   *   들어서기만 하면 저 혼자 뜬다 — 사용자가 한 일이 없으니 무엇 때문에 떴는지
   *   알 수 없고, 되돌릴 방법도 없다. 게다가 내 정보에 들를 때마다 **매번** 떴다
   *   (탭을 옮겼다 돌아오면 화면이 다시 마운트되므로).
   *   실패한 것은 화면 전체가 아니라 **알림 설정 한 구획**이다. 그러니 그 구획
   *   안에서 말하고, 거기서 다시 시도하게 한다.
   */
  const loadNoti = useCallback(async (isStale: () => boolean = () => false) => {
    setNotiLoadFailed(false);
    try {
      const s = await fetchNotificationSettings();
      if (isStale() || !s) return;
      setNoti(toBooleans(s));
      setQuietHours({ start: s.nightQuietStartHour, end: s.nightQuietEndHour });
    } catch {
      if (!isStale()) setNotiLoadFailed(true);
    } finally {
      if (!isStale()) setHydrated(true);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    void loadNoti(() => cancelled);
    return () => {
      cancelled = true;
    };
  }, [loadNoti]);

  useEffect(() => {
    setOtaVersion(getCurrentOtaVersion());
    setNativeVersion(getCurrentNativeVersion());
  }, []);

  // 10-tap 카운터 — 첫 탭 시점부터 TAP_WINDOW_MS 안에 TAP_THRESHOLD 번 채워야 함.
  const tapCountRef = useRef(0);
  const firstTapAtRef = useRef(0);

  const handleVersionTap = () => {
    if (debugUnlocked) return; // 이미 unlock 된 상태면 카운터 안 돎
    const now = Date.now();
    // 첫 탭이거나, 윈도우 초과 → 새 시퀀스 시작
    if (tapCountRef.current === 0 || now - firstTapAtRef.current > TAP_WINDOW_MS) {
      tapCountRef.current = 1;
      firstTapAtRef.current = now;
      return;
    }
    tapCountRef.current += 1;
    if (tapCountRef.current >= TAP_THRESHOLD) {
      tapCountRef.current = 0;
      firstTapAtRef.current = 0;
      setUnlockOpen(true);
    }
  };

  // push 가 OFF→ON 으로 전환될 때만 native 권한 선행. granted 아니면 false.
  const ensurePushIfTurningOn = async (willTurnOn: boolean): Promise<boolean> => {
    if (!willTurnOn || !isNative()) return true;
    const state = await ensurePushPermission({ allowSettingsPrompt: true });
    if (state !== "granted") {
      toast.info(t("settings.noti.permissionDenied"));
      return false;
    }
    return true;
  };

  // 마스터(푸시 알림 설정): ON 클릭 → 하위 전체 ON / OFF 클릭 → 하위 전체 OFF.
  // 방해 금지(night)는 건드리지 않는다.
  const toggleMaster = async () => {
    if (savingKey) return;
    const next = !noti.push;
    if (next && !(await ensurePushIfTurningOn(true))) return;

    const prev = noti;
    // 화면에 있는 하위(SUB_KEYS)만 따라 움직인다 — 목록에서 뺀 알림을 마스터가
    // 조용히 켜 버리면 사용자가 끌 방법이 없다.
    setNoti((p) => ({
      ...p,
      push: next,
      ...Object.fromEntries(SUB_KEYS.map((k) => [k, next])),
    }));
    setSavingKey("push");
    try {
      await updateNotificationSettings({
        pushAgreementYn: yn(next),
        ...Object.fromEntries(SUB_KEYS.map((k) => [NOTI_FIELD[k], yn(next)])),
      });
    } catch {
      setNoti(prev);
      toast.error(t("settings.noti.saveFailed"));
    } finally {
      setSavingKey(null);
    }
  };

  // 하위 토글: 켜질 때 마스터(푸시)가 꺼져 있으면 마스터도 자동 ON.
  // ⚠ 2026-08-19 부터 목록이 마스터 ON 일 때만 보이므로 autoMaster 는 사실상
  //   도달하지 않는다. 지우지는 않았다 — 목록을 다시 항상 보이게 바꾸면 필요하다.
  const toggleSub = async (k: NotiKey) => {
    if (savingKey) return;
    const next = !noti[k];
    const autoMaster = next && !noti.push;
    if (autoMaster && !(await ensurePushIfTurningOn(true))) return;

    const prev = noti;
    setNoti((p) => ({ ...p, [k]: next, ...(autoMaster ? { push: true } : {}) }));
    setSavingKey(k);
    try {
      await updateNotificationSettings({
        [NOTI_FIELD[k]]: yn(next),
        ...(autoMaster ? { pushAgreementYn: "Y" as const } : {}),
      });
    } catch {
      setNoti(prev);
      toast.error(t("settings.noti.saveFailed"));
    } finally {
      setSavingKey(null);
    }
  };

  // 방해 금지: 마스터와 독립적인 quiet hours 토글.
  const toggleNight = async () => {
    if (savingKey) return;
    const next = !noti.night;

    const prev = noti;
    setNoti((p) => ({ ...p, night: next }));
    setSavingKey("night");
    try {
      await updateNotificationSettings({ nightQuietUseYn: yn(next) });
    } catch {
      setNoti(prev);
      toast.error(t("settings.noti.saveFailed"));
    } finally {
      setSavingKey(null);
    }
  };


  // ── ② 내 통계 (FN-041) — 실 데이터 ───────────────────────────
  const collection = useCollectionQuery();
  const stats = useMemo(() => {
    const summary = collection.data?.summary;
    return {
      cardCount: summary?.totalQuantity ?? 0,
      // 이력은 보관 상한까지만 남는다 — 통계도 화면(홈 §4)과 같은 수를 말해야 한다
      scanCount: listRecentScans().length,
      totalAmt: summary?.totalValue ?? 0,
      valuedQuantity: summary?.valuedQuantity ?? 0,
    };
  }, [collection.data]);
  const hasCards = stats.cardCount > 0;

  /** SC-017 통화 검색 — 코드로 찾는다(원화/USD 처럼 이름으로 찾진 않는다). */
  const currencyMatches = useMemo(() => {
    /* 코드 + 통화명 (SC-017 · FN-006 공통 규칙, design 2026-08-28).
       '달러' 로 USD·AUD·CAD… 가 다 걸린다. */
    const q = currencyQuery.trim().toLowerCase();
    return CURRENCIES.filter((c) =>
      q ? c.code.toLowerCase().includes(q) || t(c.nameKey).toLowerCase().includes(q) : true,
    );
  }, [currencyQuery, t]);

  const currencyLabel = (code: string) => {
    const found = CURRENCIES.find((c) => c.code === code);
    return found ? `${found.code} (${found.symbol})` : code;
  };

  const changeLanguage = async (next: AppLanguage) => {
    setLanguage(next);
    await setAppLanguage(next);
    setOpenSheet(null);
  };

  // 토글은 hydration 전이거나 다른 토글이 저장 중이면 잠근다.
  /* 못 불러온 상태에서 스위치를 열어 두면 **전부 꺼져 있다고 거짓말**을 한다.
     실제 값을 모르는 것이지 꺼져 있는 것이 아니다. */
  const notiLocked = !hydrated || notiLoadFailed || savingKey !== null;

  const sheetTitle: Record<SettingSheet, string> = {
    currency: t("display.currency"),
    language: t("display.language"),
    edition: t("display.edition"),
  };

  return (
    <PullToRefresh onRefresh={handlePullRefresh}>
      <Section variant="transparent" padding={5} maxWidth={720} width="100%" minHeight="100%">
        <VStack gap={6}>
          {/* ── ① 계정 ─────────────────────────────────────────── */}
          <Card padding={5}>
            {/* 프로필 수정은 **우측 상단의 Edit 아이콘**이다 (design 2026-08-28). 전에는
                '프로필 수정' 보조 버튼이 아바타 줄 오른쪽에 있었는데, 소개 문구가
                길어지면 다음 줄로 밀려 카드 한가운데 큰 버튼이 서 있었다. 이 카드에서
                동작은 하나뿐이라 글자로 부를 필요가 없고, 연필은 '이 칸을 고친다' 를
                자리로 말한다 — 컬렉션 자산존의 편집 아이콘과 같은 문법이다.
                ⚠ align="start" — 아이콘은 카드 **모서리**에 앉는다. center 로 두면
                  소개가 두 줄일 때 아이콘이 카드 중간으로 내려온다. */}
            <HStack gap={3} justify="between" align="start">
              <HStack gap={3} align="center">
                <Avatar
                  size="lg"
                  name={displayName}
                  src={user?.profileImageUrl ?? undefined}
                />
                <VStack gap={0.5}>
                  {/* 이름 옆 '무료' 배지를 걷었다 (2026-08-25). 플랜이 열거된
                      상태이긴 하나, **고를 다른 플랜이 없으면 상태가 아니다** —
                      모두가 같은 값을 다는 배지는 아무것도 구분하지 않는다.
                      구독 칸과 같은 이유로 함께 나갔다. */}
                  <Text weight="semibold">{displayName}</Text>
                  <Text type="supporting" color="secondary" maxLines={1}>
                    {introductionText}
                  </Text>
                </VStack>
              </HStack>
              <IconButton
                variant="ghost"
                size="sm"
                icon={<Icon name="Edit" size="sm" />}
                label={t("editProfile")}
                clickAction={() => openRoute("/me/profile")}
              />
            </HStack>
          </Card>

          {/* ── ② 내 통계 (FN-041) ─────────────────────────────── */}
          <VStack gap={3}>
            <Heading level={3}>{t("stats.sectionTitle")}</Heading>

            {!hasCards ? (
              <EmptyState
                title={t("stats.empty")}
                description={t("stats.emptyBody")}
                actions={
                  <Button
                    variant="primary"
                    label={t("stats.goScan")}
                    clickAction={() => openRoute("/scan")}
                  />
                }
              />
            ) : (
              <>
                {/*
                  통계 3칸 — 2열 + 마지막 칸 전폭.
                  ⚠ 3열로 두면 모바일에서 2열로 접히면서 **세 번째가 반쪽으로 혼자
                    남는다.** 하필 그게 총 평가액이라 가장 긴 숫자가 가장 좁은 자리에
                    들어가고 오른쪽은 빈 채로 남았다(실측 434px).
                  그래서 열은 2로 고정하고 총 평가액만 GridSpan 으로 전폭을 준다 —
                  명세의 순서(내 카드 · 스캔 기록 · 총 평가액)는 그대로다.
                */}
                <Grid gap={3} columns={{ minWidth: 140, max: 2 }}>
                  <Card padding={4}>
                    <VStack gap={1}>
                      <Text type="supporting" color="secondary">{t("stats.cardCount")}</Text>
                      <Text type="large" weight="bold">
                        {t("stats.cardUnit", { count: stats.cardCount })}
                      </Text>
                    </VStack>
                  </Card>
                  <Card padding={4}>
                    <VStack gap={1}>
                      <Text type="supporting" color="secondary">{t("stats.scanCount")}</Text>
                      <Text type="large" weight="bold">
                        {t("stats.scanUnit", { count: stats.scanCount })}
                      </Text>
                    </VStack>
                  </Card>
                  <GridSpan columns="full">
                  <Card padding={4}>
                    <VStack gap={1}>
                      <Text type="supporting" color="secondary">{t("stats.totalAmt")}</Text>
                      {/* 고액은 만/억을 병기한다 (PRD §3.2) */}
                      <Text type="large" weight="bold">{formatKrw(stats.totalAmt)}</Text>
                      {formatKrwCompact(stats.totalAmt) && (
                        <Text type="supporting" color="secondary">
                          {formatKrwCompact(stats.totalAmt)}
                        </Text>
                      )}
                      {/* §6.3 — 평가액은 시세 있는 카드만 집계된다. 분모를 밝힌다 */}
                      {stats.valuedQuantity < stats.cardCount && (
                        <Text type="supporting" color="secondary">
                          {t("collection.valuedBasis", {
                            ns: "card",
                            valued: stats.valuedQuantity,
                            total: stats.cardCount,
                          })}
                        </Text>
                      )}
                    </VStack>
                  </Card>
                  </GridSpan>
                </Grid>
              </>
            )}
          </VStack>

          {/* ── ② 후원 (SC-005 §② · 수익모델 §4) ────────────────────
              구독이 있던 자리다. 수익 모델이 광고 + 개발자 후원으로 정해지면서
              (OI-20) 그 칸을 걷고 여기에 후원을 놓는다.

              ⚠ **상설 진열이지 넛지가 아니다.** 넛지(스캔 직후·저장 완료·공유
                뒤 · FN-059)는 세션당 0~1회에 닫으면 7일 침묵이라는 빈도 규칙이
                따로 있다. 여기는 찾아온 사람에게 늘 열려 있는 자리다.
              ⚠ 건전지 0개면 개수를 적지 않는다. '건전지 0개' 는 부재를 세는
                표시라 만들지 않기로 했다 (수익모델 §4.3). */}
          {donationEnabled && (
          <VStack gap={3}>
            <Heading level={3}>{t("donation.sectionTitle")}</Heading>
            <List>
              <Item
                as="li"
                /* 라벨을 액센트로 (2026-08-27). 이 목록에서 유일하게 '해 보시겠어요'
                   인 줄이라, 설정 항목들과 같은 색이면 목록에 묻힌다.
                   ⚠ Astryx Item 은 라벨 색 프롭이 없어 노드로 넘긴다. */
                label={
                  <Text type="body" weight="medium" color="accent">
                    {t("donation.manage")}
                  </Text>
                }
                description={
                  batteryCount > 0
                    ? t("donation.mine", { count: batteryCount })
                    : t("donation.empty")
                }
                onClick={() => setDonationOpen(true)}
                endContent={<Icon name="Battery" size="sm" color={batteryColor} />}
              />
            </List>
          </VStack>
          )}

          {/* ── ③ 표시 설정 (FN-040 · SC-017 · SC-009) ─────────── */}
          <VStack gap={3}>
            <Heading level={3}>{t("display.sectionTitle")}</Heading>
            <List hasDividers>
              <Item
                as="li"
                label={t("display.currency")}
                description={t("display.currencyDesc")}
                onClick={() => { setCurrencyQuery(""); setOpenSheet("currency"); }}
                endContent={<Text color="secondary">{currencyLabel(currency)}</Text>}
              />
              <Item
                as="li"
                label={t("display.language")}
                description={t("display.languageDesc")}
                onClick={() => setOpenSheet("language")}
                endContent={<Text color="secondary">{t(`display.languageName.${language}`)}</Text>}
              />
              <Item
                as="li"
                label={t("display.edition")}
                description={t("display.editionDesc")}
                onClick={() => setOpenSheet("edition")}
                endContent={<Text color="secondary">{t(`edition.${edition}`, { ns: "card" })}</Text>}
              />
            </List>
            {/* 통화를 뭘 고르든 §5.7 병기 규칙은 그대로라는 걸 여기서 못 박는다 */}
            <Text type="supporting" color="secondary">{t("display.originNotice")}</Text>
          </VStack>

          {/* 구획선 — 성격이 다른 묶음 사이에만 넣는다 (design 2026-08-20).
              표시/알림/지원/계정은 서로 다른 이야기다. */}
          <Divider />

          {/* ── ④ 알림 설정 (FN-063 · 2026-08-25 SC-024 폐기 → 여기로 일원화) ─
              ⚠ 명세는 여기에 **시세 임계값(±10%/7일)·요약 주기·푸시/인앱**도
                두라고 한다. BE 에 담을 필드가 없어 아직이다 — 저장되지 않는
                설정을 그리면 켠 줄 알고 나갔다가 다음에 꺼져 있다. */}
          <VStack gap={3}>
            <Heading level={3}>{t("settings.noti.sectionTitle")}</Heading>

            {/* 못 불러왔을 때 — 토스트 대신 **여기**다 (loadNoti 주석 참조).
                아래 스위치들은 잠겨 있고, 왜 잠겼는지를 이 줄이 말한다.
                다시 시도가 함께 있어야 한다 — 알리기만 하고 길이 없으면
                사용자가 할 수 있는 일이 화면을 나갔다 들어오는 것뿐이다. */}
            {notiLoadFailed && (
              <HStack gap={2} align="center" justify="between">
                <Text type="supporting" color="secondary">
                  {t("settings.noti.loadFailed")}
                </Text>
                <Button
                  variant="ghost"
                  size="sm"
                  label={t("settings.noti.retry")}
                  clickAction={() => void loadNoti()}
                />
              </HStack>
            )}

            {/* 마스터는 하위 넷을 한꺼번에 켜고 끈다 — 그래서 목록을 따로 둔다.
                한 목록에 섞으면 다섯 줄이 같은 무게로 읽혀 상하 관계가 사라진다. */}
            <List>
              <Item
                as="li"
                label={t("settings.noti.master")}
                endContent={
                  <Switch
                    label={t("settings.noti.master")}
                    isLabelHidden
                    value={noti.push}
                    onChange={() => void toggleMaster()}
                    isDisabled={notiLocked}
                  />
                }
              />
            </List>

            {/* 마스터가 꺼져 있으면 '받을 알림' 목록 자체를 감춘다 (2026-08-19).
                전에는 넷이 그대로 남아 있었는데, 마스터가 OFF 면 어차피 아무것도
                오지 않으므로 켜 봐야 소용없는 스위치 넷이 남는 셈이었다.
                방해 금지는 마스터와 독립이라 계속 보인다. */}
            {noti.push && (
              <>
                <Text type="supporting" color="secondary">{t("settings.noti.subTitle")}</Text>
                <List hasDividers>
                  {SUB_KEYS.map((k) => (
                    <Item
                      key={k}
                      as="li"
                      label={t(`settings.noti.${NOTI_I18N[k]}`)}
                      description={t(`settings.noti.${NOTI_I18N[k]}Desc`)}
                      endContent={
                        <Switch
                          label={t(`settings.noti.${NOTI_I18N[k]}`)}
                          isLabelHidden
                          value={noti[k]}
                          onChange={() => void toggleSub(k)}
                          isDisabled={notiLocked}
                        />
                      }
                    />
                  ))}
                </List>
              </>
            )}

            <List>
              <Item
                as="li"
                label={t("settings.noti.quiet")}
                description={t("settings.noti.quietDesc", {
                  start: pad2(quietHours.start),
                  end: pad2(quietHours.end),
                })}
                endContent={
                  <Switch
                    label={t("settings.noti.quiet")}
                    isLabelHidden
                    value={noti.night}
                    onChange={() => void toggleNight()}
                    isDisabled={notiLocked}
                  />
                }
              />
            </List>
          </VStack>

          <Divider />

          {/* ── ⑤ 지원 (FN-044) ─────────────────────────────────
              약관·정책과 앱 버전을 지원 아래로 합쳤다 (design 2026-08-20). 넷 다
              "궁금하거나 막혔을 때 여는 것" 이라 목적이 같은데, 제목이 셋이라 한두
              줄짜리 묶음이 세 덩어리로 갈려 있었다. */}
          <VStack gap={3}>
            <Heading level={3}>{t("support.sectionTitle")}</Heading>
            <List hasDividers>
              {SUPPORT_MENU.map((m) => (
                <Item key={m.key} as="li" label={t(`support.${m.key}`)} onClick={() => openRoute(m.to)} />
              ))}
              {LEGAL_MENU.map((m) => (
                <Item
                  key={m.key}
                  as="li"
                  label={t(`legal.${m.key}`)}
                  onClick={() => nav.open({ url: `/terms/view?type=${m.type}` })}
                />
              ))}
              {/* 앱 버전도 같은 목록에 둔다 (design 2026-08-20). 문의할 때 물어보는
                  값이고 누를 것이 있는 행이라, 목록 하나를 위해 제목을 따로 세울 이유가
                  없다. 10번 탭하면 디버그 메뉴가 열리는 것도 그대로다. */}
              <Item
                as="li"
                label={t("settings.appVersion")}
                onClick={handleVersionTap}
                endContent={
                  <Text type="supporting" color="secondary">
                    {formatAppVersion(nativeVersion, otaVersion)}
                  </Text>
                }
              />
              {debugUnlocked && (
                <Item
                  as="li"
                  label={`🔧 ${t("settings.debugMenu")}`}
                  onClick={() => navigate("/dev/debug-menu")}
                />
              )}
            </List>
          </VStack>

          <Divider />

          {/* ── ⑥ 계정 (로그아웃 · 탈퇴) ─────────────────
              📌 화면을 떠나는 액션이라 맨 아래로 내렸다 (design 2026-08-20). 설정·지원
                 사이에 끼어 있으면 스크롤 중에 손이 먼저 닿는다.
              ⚠ 백업/복구(FN-043) 행은 2026-09-07 에 뺐다(사용자 결정). 컬렉션이 서버
                저장이고 담기 자체가 로그인을 요구해 "계정에 백업"할 로컬 데이터가
                없다 — 몬프라이스(로컬 우선)의 개념이라 Peeka 에선 성립하지 않는다.
                화면정의서 SC-005 ⑥·기능명세서 FN-043 은 아직 항목을 두고 있어 문서
                정리는 별건. */}
          <VStack gap={3}>
            <Heading level={3}>{t("account.sectionTitle")}</Heading>
            <List hasDividers>
              <Item as="li" label={t("account.logout")} onClick={() => void logout()} />
              {/* 탈퇴는 되돌릴 수 없는 액션이라 글자색으로 한 번 더 표시한다.
                  Astryx Text 에는 error 색이 없어 여기만 span + 토큰. */}
              <Item
                as="li"
                label={<span className={styles.withdrawLabel}>{t("settings.withdraw")}</span>}
                onClick={() => openRoute("/me/withdraw")}
              />
            </List>
          </VStack>

        </VStack>

        {/* ── 설정 시트 (SC-017 등) ──────────────────────────────── */}
        <Sheet
          open={openSheet !== null}
          onClose={() => setOpenSheet(null)}
          ariaLabel={openSheet ? sheetTitle[openSheet] : undefined}
          backKind="my-settings-sheet"
        >
          <VStack gap={4} padding={5}>
            <Heading level={3}>
              {openSheet ? sheetTitle[openSheet] : ""}
            </Heading>

            {/* SC-017 통화 선택 — 검색 + 목록. 원본 통화를 위로 올린다. */}
            {openSheet === "currency" && (
              <VStack gap={3}>
                <TextInput
                  label={t("display.currencySearch")}
                  isLabelHidden
                  placeholder={t("display.currencySearch")}
                  value={currencyQuery}
                  onChange={setCurrencyQuery}
                />
                {currencyMatches.length === 0 && (
                  <Text type="supporting" color="secondary">{t("display.currencyEmpty")}</Text>
                )}
                {(["source", "other"] as const).map((group) => {
                  const list = currencyMatches.filter((c) => c.isSource === (group === "source"));
                  if (list.length === 0) return null;
                  return (
                    <VStack key={group} gap={2}>
                      <Text type="supporting" color="secondary">
                        {group === "source" ? t("display.currencySource") : t("display.currencyOther")}
                      </Text>
                      <HStack gap={1} wrap="wrap">
                        {list.map((c) => (
                          <ToggleButton
                            key={c.code}
                            size="sm"
                            data-compact=""
                            label={`${c.code} ${c.symbol} · ${t(c.nameKey)}`}
                            isPressed={c.code === currency}
                            onPressedChange={() => { setCurrency(c.code); setOpenSheet(null); }}
                          />
                        ))}
                      </HStack>
                    </VStack>
                  );
                })}
                <Text type="supporting" color="secondary">{t("display.originNotice")}</Text>
                {/* 환율 기준일 — PRD §7 "최근 업데이트 시각 상시 노출". 언제 것인지 안 밝히면
                    환산가가 실시간처럼 읽힌다. 원화를 고르면 환산이 없어 표시하지 않는다.
                    ⚠ 환율을 못 받았으면 안내 대신 "환산할 수 없다"를 말한다 — 통화를 골라도
                      원래 통화로 적히는 이유가 화면에 있어야 한다. */}
                {currency !== DEFAULT_DISPLAY_CURRENCY && (
                  <Text type="supporting" color="secondary">
                    {money.rateBaseDate
                      ? t("display.fxBasis", { date: money.rateBaseDate })
                      : t("display.fxUnavailable")}
                  </Text>
                )}
              </VStack>
            )}

            {openSheet === "language" && (
              <HStack gap={1} wrap="wrap">
                {SUPPORTED_LANGUAGES.map((lng) => (
                  <ToggleButton
                    key={lng}
                    size="sm"
                    data-compact=""
                    label={t(`display.languageName.${lng}`)}
                    isPressed={lng === language}
                    onPressedChange={() => void changeLanguage(lng)}
                  />
                ))}
              </HStack>
            )}

            {/* SC-009 — 홈·검색의 선행 선택과 같은 전역 상태를 여기서도 바꾼다 */}
            {openSheet === "edition" && (
              <HStack gap={1} wrap="wrap">
                {EDITIONS.map((e) => (
                  <ToggleButton
                    key={e}
                    size="sm"
                    data-compact=""
                    label={t(`edition.${e}`, { ns: "card" })}
                    isPressed={e === edition}
                    onPressedChange={() => { setEdition(e); setOpenSheet(null); }}
                  />
                ))}
              </HStack>
            )}

          </VStack>
        </Sheet>

        <DonationSheet
          open={donationOpen && donationEnabled === true}
          onClose={() => setDonationOpen(false)}
          count={batteryCount}
          onDonated={() => void queryClient.invalidateQueries({ queryKey: BATTERY_KEY })}
          memberKey={me?.memberSerialNo != null ? String(me.memberSerialNo) : null}
        />

        <DebugUnlockDialog
          open={unlockOpen}
          onClose={() => setUnlockOpen(false)}
          onUnlock={() => navigate("/dev/debug-menu")}
        />
      </Section>
    </PullToRefresh>
  );
}
